import { render } from "./ShowClosedToggle.vue?vue&type=template&id=3b21dace&ts=true"
import script from "./ShowClosedToggle.vue?vue&type=script&lang=ts"
export * from "./ShowClosedToggle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__